export default __webpack_public_path__ + "static/media/user.abe75453.svg";